import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  // connectedCallback() {
  //   super.connectedCallback();
  //   document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  //   document.querySelectorAll('.cart_tab--header button.tab-btn').forEach((button) => {
  //     button.addEventListener('click', function () {
  //       cartTabs(this);
  //     });
  //   });
  // }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    document.querySelectorAll('.cart_tab--header .tab-btn').forEach((button, index) => {
      button.dataset.index = index;

      button.addEventListener('click', function () {
        cartTabs(this);
      });
    });

    document.querySelectorAll('.cart_tab--content .tab-content').forEach((content, index) => {
      content.dataset.index = index;
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}


// const cartTabs = (button) => {
//     const index = button.dataset.index;

//     // Remove 'active' from all tab buttons
//     document.querySelectorAll('.cart_tab--header button').forEach((btn) => {
//       btn.classList.remove('active');
//     });

//     // Add 'active' to the clicked button
//     button.classList.add('active');

//     // Remove 'active' from all tab contents
//     document.querySelectorAll('.cart_tab--content .tab-content').forEach((content) => {
//       content.classList.remove('active');
//     });

//     // Add 'active' to the matching tab content
//     const activeContent = document.querySelector(`.cart_tab--content .tab-content[data-index="${index}"]`);
//     if (activeContent) {
//       activeContent.classList.add('active');
//     }
// };
const cartTabs = (button) => {
    const wrapper = button.closest('.cart_tab--wrapper');
    const index = button.dataset.index;

    // Remove active from buttons in current wrapper only
    wrapper.querySelectorAll('.cart_tab--header .tab-btn').forEach((btn) => {
        btn.classList.remove('active');
    });

    button.classList.add('active');

    // Remove active from contents in current wrapper only
    wrapper.querySelectorAll('.cart_tab--content .tab-content').forEach((content) => {
        content.classList.remove('active');
    });

    // Get matching content
    const activeContent = wrapper.querySelector(
        `.cart_tab--content .tab-content[data-index="${index}"]`
    );

    if (activeContent) {
        activeContent.classList.add('active');
    }
};

